module.exports = __webpack_public_path__ + "img/imagem-produto.39b7ad4c.png";